import React from "react";

const Pill = ({ children, active = false, onClick }) => {
    return (
        <span className={`cursor-pointer rounded-full py-1 px-3 text-xs font-semibold border  transition-all ${active ? 'bg-custom-light-blue text-custom-dark border-custom-light-blue' : 'bg-custom-charcoal text-custom-light-blue border-custom-charcoal hover:border-custom-light-blue'}`} onClick={onClick}>
            {children}
        </span>
    );
};

export default Pill;
